import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as User from '../../helpers/User';
import ActiveObservers from './ActiveObservers';
import YetactiveObservers from './YetactiveObservers';

const $= window.$;

class ObserverView extends Component {
	constructor(props) {
		super(props);
        this.state={
          
            
          
        };
       
	}


	otherFunc() {

	    this.props.callFun();
	  }


    componentDidMount() {
    	
    }

		render() {

			const {actyetact} = this.props;
			let activeob = '';
			let yetactiveob = '';
			if(actyetact != undefined || actyetact != null){

			activeob = actyetact.map((active,i)=>{

					return(

						<ActiveObservers key={`active_${i}`} activeob={active.activeob} />

						)

				});
			}


			if(actyetact != undefined || actyetact != null){
				yetactiveob = actyetact.map((yetob,i)=>{

					return(

						<YetactiveObservers key={`yetob_${i}`} yetactiveob={yetob.yetactiveob} />

						)

				});
				 
			}
			//alert(JSON.stringify({actyetact}));

			
			return (
				<div className="tabgrey viewobservers">
				  <div id="ChildVerticalTab_1">
				      <ul className="resp-tabs-list ver_1">
				          <a href="javascript:void(0)" id="actob" onClick={this.otherFunc.bind(this)}><li >Active Observers</li></a>
				          <a href="javascript:void(0)" id="yetob" onClick={this.otherFunc.bind(this)}><li >Yet to be Observers </li></a>
				      </ul>
				      <div className="resp-tabs-container ver_1">
				          <div className="verticaltab-content activeobs">
				            <div className="activeobs-tbl">
				            	{activeob}
				            </div>                                                                
				          </div>
				          <div className="verticaltab-content inactiveobs">
				          	<div className="inactiveobs-tbl" >
				          		{yetactiveob}
				          	</div>
				            <div id="testforms" ></div>
				          </div>
				      </div>
				  </div>
				</div>
			);
		}
}

export default ObserverView;



// WEBPACK FOOTER //
// ./src/personal_interactions/observer/ObserverView.js